var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BAG",
    d: "M20.31659,9.39728c-.21252-1.75714-1.31171-8.50781-5.66766-8.50781-4.3576,0-5.68372,6.78009-5.95123,8.50781h-4.21851v16.74689c0,2.72742,3.49585,3.34906,3.64478,3.37408v-.00006l12.80505.00641c2.8103,0,3.77209-2.37842,3.88971-3.67749V9.39728h-4.50214ZM14.64893,1.79468c3.48798,0,4.52234,5.86487,4.75256,7.6026h-9.78381c.29572-1.758,1.54034-7.6026,5.03125-7.6026ZM11.6756,26.97083c-1.78436-1.85333,2.38721-1.34888,2.48639.43323-.17651.93671-2.06458.00494-2.48639-.43323ZM15.69861,27.51056c-.38654-.60962,1.13983-1.62207,1.64954-1.73016.28009-.05939.92175-.12964,1.0976.11462.39087,1.07574-2.21991,2.44696-2.74713,1.61554ZM20.92902,28.61938l-2.09174.00488c.00061-.00165.00122-.0033.00195-.00488,1.42133-3.15033.74652-7.46942-3.29199-7.84387-4.78308-.44354-6.40063,4.01373-4.5788,7.82654l-2.72687.01733c-.32404-.06451-2.85718-.62921-2.85718-2.47522v-15.84167h18.52905l.0022,15.50177c-.01147.11511-.30627,2.81512-2.98663,2.81512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/ShopIcon.87819b1b2d13062b3034465cd3352231.svg";
export { ForwardRef as ReactComponent };